import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["textAlign", "verticalAlign", "className"];
import React from 'react';
import { Grid } from 'semantic-ui-react';
import { getTextAlignClass, getVerticalAlignClass } from './GridColumnFlex.utils';
import { TextAlignPropType, VerticalAlignPropType } from '../../services/proptypes';
import './GridColumnFlex.css';
var defaultProps = {
  className: undefined,
  textAlign: 'center',
  verticalAlign: 'middle'
};
function GridColumnFlex(_ref) {
  var textAlign = _ref.textAlign,
    verticalAlign = _ref.verticalAlign,
    className = _ref.className,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  var allClassNames = [className, getTextAlignClass(textAlign), getVerticalAlignClass(verticalAlign)].join(' ');
  return /*#__PURE__*/React.createElement(Grid.Column, _extends({
    className: "grid-column-flex ".concat(allClassNames)
  }, passThroughProps));
}
GridColumnFlex.defaultProps = defaultProps;
export default GridColumnFlex;